
export const customStyles = {
    control: (provided) => ({
        ...provided,
        backgroundColor: 'transparent',
        color: 'var(--bgColorSecondary)',
    }),
    singleValue: (provided) => ({
        ...provided,
        color: 'var(--textColor)',
    }),
    placeholder: (provided) => ({
        ...provided,
        color: 'var(--bgColorSecondary)',
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected ? 'var(--bgColor)' : 'var(--bgColor)',
        color: state.isSelected ? 'var(--textColor)' : 'var(--textColor)',
        '&:hover': {
            backgroundColor: 'yourHoverBackgroundColor',
            color: 'var(--textColor)',
        },
    }),
    menu: (provided) => ({
        ...provided,
        backgroundColor: 'var(--bgColor)',
    }),
};


